import strings from "global/constants/StringConstants";
import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const getInvoicesData = async (pageNumber: number, limit: number) => {
  const url = `${urls.GET_INVOICE_PAGE}/${pageNumber}/limit/${limit}`;
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getInvoicesCount = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(urls.GET_BILL_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const checkActivePlan = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(urls.PLAN_STATUS, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
export const getBillCount = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(urls.GET_BILL_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getCurrentPlan = async (accountName: string) => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(
      `${urls.GET_CURRENT_PLAN}/${accountName}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getUpdatePrimaryCard = async (paymentId: String) => {
  try {
    const callParams = await getCallParams("POST");
    const response: any = await makeCall(
      `${urls.UPDATE_CARD}/${paymentId}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getSaveCards = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(`${urls.GET_ALL_PLANS}`, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
export const updatePlan = async (planId: string, addDiscount: boolean) => {
  try {
    const callParams = await getCallParams("POST");
    const response: any = await makeCall(
      `${urls.UPDATE_PLAN}/${planId}/discount/${addDiscount}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const verifyCoupon = async (
  couponCode: string,
  planId: string,
  account: string,
) => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(
      `${urls.VERIFY_COUPON}/${couponCode}/planId/${planId}/account/${account}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addPaidCustomer = async (data: any, addDiscount: boolean) => {
  try {
    const callParams = await getCallParams("POST", data);
    const response: any = await makeCall(
      `${urls.ADD_PAID_CUSTOMER}/discount/${addDiscount}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const cancelPlan = async () => {
  try {
    const callParams = await getCallParams("DELETE");
    const response: any = await makeCall(urls.CANCEL_PLAN, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAccountStats = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(
      urls.FETCH_ACCOUNT_DETAILS,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const setDefaultCard = async (id: any) => {
  try {
    const callParams = await getCallParams("POST");
    const url = `${urls.UPDATE_CARD}/${id}`;
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addPaymentMethod = async (id: any, defaultCard: any) => {
  try {
    const url = `${urls.addCard}/${id}/${defaultCard}`;
    const callParams = await getCallParams("POST");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
